import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var percent_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(
  Path,
  {
    fillRule: "evenodd",
    d: "M6.5 8a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM8 5a3 3 0 100 6 3 3 0 000-6zm6.5 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm1.5-3a3 3 0 100 6 3 3 0 000-6zM5.47 17.41a.75.75 0 001.06 1.06L18.47 6.53a.75.75 0 10-1.06-1.06L5.47 17.41z",
    clipRule: "evenodd"
  }
) });
export {
  percent_default as default
};
//# sourceMappingURL=percent.js.map
